import { Component, effect, inject, signal, ViewEncapsulation } from '@angular/core'
import { VetSchedulePlannerService } from '../vet-schedule-planner.service'
import { Doctor, VSPDoctor_Type } from 'src/app/shared/services/ppv.api'
import * as datefns from 'date-fns'
import { ToastrService } from 'ngx-toastr'
import * as EnumHelper from '../enum-helper'

@Component({
   selector: 'vsp-add-doctor-dialog',
   standalone: false,
   templateUrl: './add-doctor-dialog.component.html',
   styleUrl: './add-doctor-dialog.component.scss',
   encapsulation: ViewEncapsulation.None,
})
export class AddDoctorDialogComponent {
   service = inject(VetSchedulePlannerService)
   doctorTypes = EnumHelper.enumToValueLabelArray(EnumHelper.doctorTypes).filter((dt) => dt.value > VSPDoctor_Type.Employee)
   reliefTypes = [
      { label: 'Agency', value: true },
      { label: 'Individual', value: false },
   ]
   dayforceResults: Array<{ label: string; id: string }> = []

   VSPDoctor_Type = VSPDoctor_Type

   reliefType = signal<boolean | null>(null)
   selectedDoc = signal<Doctor | null>(null)

   doctorExists = signal(false)

   constructor(private toastr: ToastrService) {
      effect(() => {
         if (!this.service.selectedDoctor()?.dayforceId) {
            this.selectedDoc.set(null)
         }
         if (!this.service.selectedDoctor()?.type) {
            this.reliefType.set(null)
         }
      })

      effect(() => {
         if (this.service.addDoctorDialogVisible() == true) {
            this.doctorExists.set(false)
         }
      })
   }

   isValid(): boolean {
      if (!this.service.selectedDoctor().type) return false
      if (this.service.selectedDoctor().type === VSPDoctor_Type.LendAHand) return !!this.service.selectedDoctor().dayforceId
      if (this.service.selectedDoctor().type === VSPDoctor_Type.Relief) {
         if (this.reliefType() === null) {
            return false
         }
         if (this.reliefType() === true) {
            return !!this.service.selectedDoctor().agencyName && !!this.service.selectedDoctor().firstName && !!this.service.selectedDoctor().lastName
         }
         return !!this.service.selectedDoctor().firstName && !!this.service.selectedDoctor().lastName
      }
      return true
   }

   searchDayforceEmployees(event: any) {
      this.service.searchActiveDfDoctors(event.query).subscribe((results) => {
         this.dayforceResults = results.map((r) => {
            let label = `${r.firstName} ${r.lastName} (${r.practiceName})`
            return {
               label,
               id: r.employeeXRefCode,
               name: `${r.firstName} ${r.lastName}`,
               firstName: r.firstName,
               lastName: r.lastName,
            }
         })
      })
   }

   onDayforceIdChange(selected: any) {
      console.log('Selected doctor:', selected)
      this.service.selectedDoctor().dayforceId = selected.value.id
      this.service.selectedDoctor().firstName = selected.value.firstName
      this.service.selectedDoctor().lastName = selected.value.lastName
   }

   cancel() {
      this.service.addDoctorDialogVisible.set(false)
   }

   save() {
      console.log('Saving doctor:', this.service.selectedDoctor())
      this.service.isLoading.set(true)
      this.service.selectedDoctor().practiceSKey = this.service.week()!.practiceSKey
      this.service.selectedDoctor().startDate = datefns.format(this.service.week().firstDay, 'yyyy-MM-dd') as any
      this.service.doesDoctorExist(this.service.selectedDoctor()).subscribe({
         next: (exists) => {
            if (exists) {
               this.service.showError('Doctor already exists.')
               this.doctorExists.set(true)
               this.service.isLoading.set(false)
            } else {
               this.service.saveDoctorChanges().subscribe({
                  next: (id) => {
                     let days = []
                     for (let i = 0; i < 7; i++) {
                        days.push({
                           date: datefns.addDays(this.service.week()!.firstDay, i),
                           doctorId: id,
                           endTime: null,
                           id: 0,
                           startTime: null,
                           type: 0,
                           weekId: this.service.week()!.id,
                           weekday: i,
                        })
                     }
                     console.log('Created days for new doctor:', days)
                     this.service.selectedDoctor()!.days = days
                     this.service.week().doctors.push(this.service.selectedDoctor()!)
                     this.service.addDoctorDialogVisible.set(false)
                     this.toastr.success('New doctor added successfully.')
                  },
                  complete: () => {
                     this.service.isLoading.set(false)
                  },
                  error: () => {
                     this.service.showError('Failed to add the new doctor.')
                     this.service.isLoading.set(false)
                  },
               })
            }
         },
         error: () => {
            this.service.showError('Failed to check if doctor exists.')
            this.service.isLoading.set(false)
         },
      })
   }
}
